import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireObject } from '@angular/fire/database';
import { Contact } from '../Models/contact';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private db: AngularFireDatabase) { }

  createContact(contact) {
    return this.db.list('/contacts').push(contact);
  };

  getAllContact() {
    return this.db.list<Contact>('/contacts').snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.payload.key, ...c.payload.val() }));
    });

  }
  get(contactId){
    return this.db.object('/contacts/'+ contactId);
  }
  
  update(contactId, contacts){
    return this.db.object('/products/'+ contactId).update(contacts);
  }
  delete(contactId){
    return this.db.object('/products/'+ contactId).remove();
  }




}
